module.exports = __webpack_public_path__ + "media/img/illustrations/icons/action-recall-agency-c0b9888ce1ef5774a51916648c82b74d.svg";